import { ref, onMounted, onUnmounted } from 'vue'

/**
 * 监听滚动位置，返回是否超过阈值
 * @param threshold 滚动阈值（像素），默认 80
 */
export function useScrollSpy(threshold = 80) {
  const isScrolled = ref(false)

  let rafId: number | null = null

  function handleScroll() {
    if (rafId !== null) return
    rafId = requestAnimationFrame(() => {
      isScrolled.value = window.scrollY > threshold
      rafId = null
    })
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    if (rafId !== null) {
      cancelAnimationFrame(rafId)
    }
  })

  return { isScrolled }
}
